import { makeStyles, Grid, Skeleton, Spacer } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2)
  }
}))

export interface EditDealShimProps {}

export default function EditDealShim(props: EditDealShimProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      {/* header */}
      <Grid container spacing={1}>
        <Grid item xs={12} sm={7} md={4}>
          <Skeleton width="100%" height="100px" />
        </Grid>
      </Grid>
      <Spacer height={30} />
      {/* main body */}
      <Grid container spacing={3}>
        {/* left side */}
        <Grid item xs={6}>
          <Skeleton width="100%" height="350px" />
          <Spacer height={30} />
          <Skeleton width="100%" height="150px" />
          <Spacer height={30} />
          <Skeleton width="100%" height="300px" />
        </Grid>
        {/* right side */}
        <Grid item xs={6}>
          <Skeleton width="100%" height="300px" />
          <Spacer height={30} />
          <Skeleton width="100%" height="800px" />
        </Grid>
      </Grid>
      <Spacer height={30} />
    </div>
  )
}
